// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Detail component
 */
import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import LeftContent from 'modules/ReportDesigner/Fields/Izenda.LeftContentFieldDetail';
import RightContent from 'modules/ReportDesigner/Fields/Izenda.RightContentFieldDetail';
import actions from 'modules/ReportDesigner/Fields/Izenda.FieldDetailActions';
import Dimensions from 'share/components/hoc/Izenda.Dimensions';
import { observable } from 'mobx';

@connect({ toClass: true }, actions, Dimensions)
class FieldDetail extends Component {

  @observable bottom;
  // make sure a loader
  // triggered in child components work correctly
  constructor(props: any) {
    super(props);
    const { registerObserveLoading, isReloadView, store } = props;
    this.bottom = 0;

    registerObserveLoading(this);

    !isReloadView && store.loadInitial();
  }

  componentWillUnmount() {
    this.props.unregisterObserveLoading(this);
  }

  componentDidMount() {
    const rect = this.container.getBoundingClientRect();
    this.bottom = window.innerHeight - (rect.top + rect.height);
  }

  setRef = (dom: any) => {
    this.container = dom;
  }

  render() {
    const { store, uiStore, pageName, height } = this.props;

    return (
      <div className="izenda-Wrapper-content" ref={this.setRef}>
        <div className="izenda-FieldsDetail izenda-TableLayout">
          <div className="izenda-TableLayout-Cell">
            <LeftContent bottom={this.bottom} height={height} store={store} uiStore={uiStore} pageName={pageName} />
          </div>
          <RightContent fieldStore={store} reportDesignerModel={store.masterModel} uiStore={uiStore} />
        </div>
      </div>
    );
  }
}

FieldDetail.displayName = 'FieldDetail';

export default FieldDetail;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.FieldDetail.js